import React from "react";
import { useLocation } from "react-router-dom";
import RequestPasswordResetForm from "../../components/Forms/RequestResetPasswordForm";

function RequestResetPassword({ activation }) {
  const { search } = useLocation();

  // Appen öppnar sidan med ?isFromApp=true. Flaggan följer med i mejlets länk så att
  // användaren skickas tillbaka till appen när lösenordet är uppdaterat.
  const isFromApp =
    !activation &&
    new URLSearchParams(search).get("isFromApp")?.toLowerCase() === "true";

  return (
    <RequestPasswordResetForm activation={activation} isFromApp={isFromApp} />
  );
}

export default RequestResetPassword;
